import { SongId } from "../models/Song";
import { OwnerId } from "../models/User";
import { toDateSeconds, uuidv4 } from "../util/sugar";
import { ArtistService } from "./ArtistService";
import { s3Config } from "../config/env";

interface S3UploadParams {
  fields: {
    AWSAccessKeyId: string
    acl: string
    key: string
    policy: string
    signature: string
  },
  fileUrl: string
  uploadUrl: string
}


export class TransmissionService {

  static FetchTodaysTransmission = (ownerId: OwnerId) => {
    return new Promise<SongId | null>((resolve, reject) => {
      ArtistService.fetchLatestSong(ownerId).then((song) => {
        const today = new Date().setHours(0, 0, 0, 0);
        const thatDay = new Date(toDateSeconds(song.updatedAt)).setHours(0, 0, 0, 0);
        if (today === thatDay) {
          resolve(song.id);
        } else {
          resolve(null);
        }
      }).catch(reject);
    });
  }

  static GeneratePreSignedURL = (ownerId: string, collection: string, fileExtension: string): S3UploadParams => {

    const key = collection + "/" + ownerId + "/" + uuidv4() + "." + fileExtension;
    const bucketUrl = s3Config.bucketUrl.replace(/\/$/, '');
    return {
      fields: {
        AWSAccessKeyId: s3Config.accessKeyId,
        acl: "private",
        key: key,
        filename: key,
        policy: s3Config.policy,
        signature: s3Config.signature,
        "Content-Type": collection
      },
      fileUrl: `${bucketUrl}/${key}`,
      uploadUrl: `${bucketUrl}/`
    } as S3UploadParams;
  }

}